import module from 'nominas/nomina/module.js'

const findSuministro = (suministros, idEmpresa, idEmpleado) => {
  return suministros.find((item) => {
    return (item.id_empresa === idEmpresa && item.id_empleado === idEmpleado)
      || (item.ID_Empresa === idEmpresa && item.ID_Empleado === idEmpleado)
  })
}

export class NominasNominaExportarBancosService {
  constructor ($q, NominasNomina, NominasNominaSuministro, NominasNominaBancos, NominasNominaEmpleados, NominasNominaMovimientos) {
    this.$q = $q
    this.NominasNomina = NominasNomina
    this.NominasNominaSuministro = NominasNominaSuministro
    this.NominasNominaBancos = NominasNominaBancos
    this.NominasNominaEmpleados = NominasNominaEmpleados
    this.NominasNominaMovimientos = NominasNominaMovimientos
  }

  get (idEmpresa, idNomina, logotipo, legacy, departamento) {
    return this.$q.all({
        nomina: this.NominasNomina.get(idEmpresa, idNomina),
        suministro: legacy ? this.NominasNominaSuministro.get(idEmpresa, idNomina) : this.NominasNominaMovimientos.get(idEmpresa, idNomina)
          .then((response) => (response.data)),
        colaboradores: this.NominasNominaEmpleados.get(idEmpresa, idNomina),
        bancos: this.NominasNominaBancos.get(idEmpresa, idNomina),
      })
      .then(($resolve) => {
        let nomina = $resolve.nomina
        let nominaColaboradores = $resolve.colaboradores
        let nominaSuministro = $resolve.suministro
        let nominaBancos = $resolve.bancos

        let data = nominaColaboradores.map(function (empleado, index) {
          let cuentas = nominaBancos[index].Bancos
          let suministro = findSuministro(nominaSuministro, empleado.ID_Empresa, empleado.ID_Empleado)
          let total = 0

          if (legacy) {
            total = suministro.Total
            Object.values(suministro.Deducciones)
              .reduce((total, deduccion) => total - Number.isFinite(deduccion.editado) ? deduccion.editado : deduccion.calculado, suministro.Total)
          } else {
            total = nomina.ID_Moneda === '2' ? (suministro.neto_a_pagar / nomina.Tipo_Cambio) : suministro.neto_a_pagar
          }

          let cuenta
          if (cuentas[0].ID_Moneda === nomina.ID_Moneda) {
            cuenta = cuentas[0]
          } else if (cuentas[1].ID_Moneda === nomina.ID_Moneda) {
            cuenta = cuentas[1]
          } else {
            cuenta = cuentas[2]
          }

          return [
            empleado.ID_Empresa,
            empleado.ID_Empleado,
            empleado.Empleado,
            empleado.Departamento,
            total,
            cuenta.Banco,
            cuenta.Moneda,
            cuenta.Cuenta,
            cuenta.Numero_Tarjeta,
            cuenta.CLABE,
            cuenta.Notas,
          ]
            .concat(nomina.ID_Moneda === '2' ? [nomina.Tipo_Cambio, nomina.Tipo_Cambio * total] : [])
        })

        let datos = [{
          name: 'Bancos',
          details: [
            {label: 'Empresa: ' + nomina.Empresa, cell: 'D1'},
            {label: 'Nómina: ' + nomina.ID_Nomina, cell: 'D2'},
            {label: 'Moneda: ' + nomina.Moneda, cell: 'D3'},
            {label: 'Departamento: Todos los departamentos', cell: 'D4'},
            {label: 'Fecha: ' + nomina.Fecha.toYMD(), cell: 'I1'},
            {label: 'Fecha de pago: ' + nomina.Fecha_Pago.toYMD(), cell: 'I2'},
          ],
          columns: ([
            {label: 'Empr.', format: {align: 'center', width: 4}},
            {label: !legacy ? 'Empl.' : 'ID', format: {align: 'center', width: 7}},
            {label: 'Nombre', format: {width: 30}},
            {label: 'Dpto.', format: {width: 10}},
            {label: 'Total', format: {type: 'currency', align: 'right', width: 10}, totalize: true},
            {label: 'Cuenta', format: {width: 20}},
            {label: 'Cuenta Moneda', format: {width: 20}},
            {label: 'Cuenta Cuenta', format: {width: 20}},
            {label: 'Cuenta Numero de tarjeta', format: {width: 20}},
            {label: 'Cuenta CLABE', format: {width: 20}},
            {label: 'Cuenta Notas', format: {width: 20}},
          ])
            .concat(nomina.ID_Moneda === '2' ? [
              {label: 'TC', format: {align: 'right', width: 8}},
              {label: 'Total MXN', format: {type: 'currency', align: 'right', width: 12}, totalize: true},
            ] : []),
          options: {
            logo: {
              filename: logotipo,
              title: 'FAN Consultores',
              cell: 'A1',
            },
            show_grid: false,
            fixed_column: 'A8',
          },
          data: data,
        }]

        if (!legacy) {
          datos[0].details.push({label: 'Fecha inicial: ' + nomina.Fecha_Inicial.toYMD(), cell: 'I3'})
          datos[0].details.push({label: 'Fecha final: ' + nomina.Fecha_Final.toYMD(), cell: 'I4'})
        }

        if (!departamento) {
          datos[0].columns.splice(3, 1)
          datos[0].data.forEach((item) => (item.splice(3, 1)))
        }

        return datos
      })
  }
}

module.service('NominasNominaExportarBancos', NominasNominaExportarBancosService)



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Exportar/Bancos.js